import {ButtonProps, Collapse, MenuItem} from "@mui/material";
import ChevronIcon from "assets/icons/ChevronIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import {CSSProperties, ReactNode, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";

interface Origin {
    color?: string;
    bgColor?: string;
    img?: string;
}

interface Open extends Origin {
    open?: boolean;
}

interface Props extends ButtonProps {
    expand?: boolean;
    children?: ReactNode;
    title?: string;
    icon?: ReactNode;
    origin?: Origin;
    extraStyle?: CSSProperties;
    item?: any;
    items?: any[];
    hover?: Origin;
    open?: Open;
    onItemClick?: (item: any) => void;
    onclick?: () => void;
    onOpen?: (item: any) => void;
}

export default function MenuButton(props: Props) {
    const navigate = useNavigate()

    const {expand, icon, title, children, extraStyle, items, hover, open} = props;
    const {onItemClick, onclick, onOpen, item} = props;
    const [isOpen, setOpen] = useState(open?.open);
    const [isHover, setHover] = useState(false);

    useEffect(() => setOpen(open?.open), [open?.open]);

    const hasChildren = items && items.length > 0;
    let origin: Origin = {...props.origin};
    const hoverChange = isHover && hover && !isOpen;
    const openChange = isOpen && open;
    if (hoverChange) origin = hover;
    if (openChange) origin = open;

    function handleClick() {
        onOpen && onOpen(item);
        if (hasChildren) setOpen((x) => !x);
        else onclick && onclick();
    }

    return (
        <div
            style={{
                ...(isOpen && expand && items && {backgroundColor: "#F4F4F4", borderRadius: 6, paddingBottom: 16}),
            }}
        >
            <BasicButton
                fullWidth={expand}
                variant={props.variant || "outlined"}
                style={{
                    ...extraStyle,
                    ...(expand && {justifyContent: "space-between", alignItems: "center", gap: 24}),
                    ...(!expand && {minWidth: 40, padding: 0}),
                    ...(origin.color && {color: origin.color}),
                    ...(origin.bgColor && {backgroundColor: origin.bgColor}),
                }}
                onClick={handleClick}
                disableFocusRipple
                disableRipple
                disableTouchRipple
                onMouseOver={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                {...props}
            >
                {
                    (!item?.url) ? <div style={{display: "flex", alignItems: "center", gap: 24}}>
                        {icon}
                        {origin.img && <img alt="" src={origin.img} width={20}/>}
                        {expand && title && <span>{title}</span>}
                        {item && expand && item.beta && <span style={{
                            position: 'absolute',
                            left: '16px',
                            fontSize: '10px',
                            backgroundColor: '#bed7fa',
                            color: '#1062d0',
                            padding: '2px 8px',
                            borderRadius: '3px',
                        }}>آزمایشی</span>}
                        {item && expand && item.isNew && <span style={{
                            position: 'absolute',
                            left: '16px',
                            fontSize: '10px',
                            backgroundColor: '#bed7fa',
                            color: '#1062d0',
                            padding: '2px 8px',
                            borderRadius: '3px',
                        }}>جدید</span>}
                        {expand && children}
                    </div> : <a href={item.url} onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        navigate(item.url)
                    }}>
                        <div style={{display: "flex", alignItems: "center", gap: 24}}>
                            {icon}
                            {origin.img && <img alt="" src={origin.img} width={20}/>}
                            {expand && title && <span>{title}</span>}
                            {item && expand && item.beta && <span style={{
                                position: 'absolute',
                                left: '16px',
                                fontSize: '10px',
                                backgroundColor: '#bed7fa',
                                color: '#1062d0',
                                padding: '2px 8px',
                                borderRadius: '3px',
                            }}>آزمایشی</span>}
                            {item && expand && item.isNew && <span style={{
                                position: 'absolute',
                                left: '16px',
                                fontSize: '10px',
                                backgroundColor: '#bed7fa',
                                color: '#1062d0',
                                padding: '2px 8px',
                                borderRadius: '3px',
                            }}>جدید</span>}
                            {expand && children}
                        </div>
                    </a>
                }
                {expand && hasChildren && <ChevronIcon rotate={isOpen ? "top" : undefined} color={origin.color}/>}
            </BasicButton>
            {expand && items && (
                <Collapse in={isOpen}>
                    {items.map((item, index) => {
                        if (item.name === "slot") return <div style={{height: 8}}/>;
                        if (!item.url) {
                            return (
                                <MenuItem
                                    key={index}
                                    style={{
                                        cursor: "default",
                                        padding: "6px 16px",
                                        fontSize: 14,
                                        marginRight: 24,
                                        display: "flex",
                                        gap: 12,
                                    }}
                                    sx={{
                                        color: item.active ? "#1062D0" : "#747575",
                                        borderRight: item.active ? "2px solid #1062D0" : "2px solid #D1D8E2",
                                        "&:hover": {
                                            backgroundColor: "transparent",
                                            color: "#1062D0",
                                            borderRight: "2px solid #1062D0",
                                        },
                                    }}
                                >
                                    {item.Icon && <div className="w-8">{item.Icon}</div>}
                                    <span>{item.name}</span>
                                </MenuItem>
                            );
                        }
                        return (
                            <Link
                                key={index}
                                to={item?.url}
                                onClick={(e) => {
                                    if (!item?.url) {
                                        e.preventDefault();
                                    }
                                }}
                            >
                                <MenuItem
                                    style={{
                                        cursor: "pointer",
                                        padding: "6px 16px",
                                        fontSize: 14,
                                        marginRight: 24,
                                        display: "flex",
                                        gap: 12,
                                    }}
                                    sx={{
                                        color: item.active ? "#1062D0" : "#747575",
                                        borderRight: item.active ? "2px solid #1062D0" : "2px solid #D1D8E2",
                                        "&:hover": {
                                            backgroundColor: "transparent",
                                            color: "#1062D0",
                                            borderRight: "2px solid #1062D0",
                                        },
                                    }}
                                    onClick={() => onItemClick && onItemClick(item)}
                                >
                                    {item.Icon && <div className="w-8">{item.Icon}</div>}
                                    <span>{item.name}</span>
                                    {item && expand && item.isNew && <span style={{
                                        position: 'absolute',
                                        left: '16px',
                                        fontSize: '10px',
                                        backgroundColor: '#bed7fa',
                                        color: '#1062d0',
                                        padding: '2px 8px',
                                        borderRadius: '3px',
                                    }}>جدید</span>}
                                </MenuItem>
                            </Link>
                        );
                    })}
                </Collapse>
            )}
        </div>
    );
}
